// Whether a customer agreed to offers on WhatsApp (getFashionConsent /
// setFashionConsent). Kept on the customer on the server, separate from bills
// and receipts. Online only: there is no offline queue for it.

// Values go as GraphQL variables, never pasted into the query text.
export const GET_CONSENT_QUERY = "query GetFashionConsent($customerId: String!) { getFashionConsent(customerId: $customerId) { customerId whatsappOffers updated updatedBy } }";
export const SET_CONSENT_MUTATION =
  "mutation SetFashionConsent($customerId: String!, $bunitId: String!, $whatsappOffers: Boolean!) { setFashionConsent(customerId: $customerId, bunitId: $bunitId, whatsappOffers: $whatsappOffers) { status message recordId documentNo } }";

export const buildConsentQuery = (customerId) => ({ query: GET_CONSENT_QUERY, variables: { customerId: String(customerId ?? "") } });

export const buildSetConsentMutation = (customerId, bunitId, whatsappOffers) => ({
  query: SET_CONSENT_MUTATION,
  variables: { customerId: String(customerId ?? ""), bunitId: String(bunitId ?? ""), whatsappOffers: whatsappOffers === true },
});

// Server response → { ok, whatsappOffers: true | false | null (never asked), updated }.
// ok is false when the call failed, so the caller can tell "never asked" from "couldn't check".
export function readConsent(response) {
  if (!response || response?.data?.errors?.length) return { ok: false, whatsappOffers: null, updated: "" };
  const c = response?.data?.data?.getFashionConsent;
  if (c === undefined) return { ok: false, whatsappOffers: null, updated: "" };
  const v = c?.whatsappOffers;
  return { ok: true, whatsappOffers: v === "Y" ? true : v === "N" ? false : null, updated: c?.updated || "" };
}
